import { fetchNewsRT } from '../api/rt-mobile';

export const FETCH_NEWS_RT_PROCESS = () => dispatch => dispatch({ type: 'FETCH_NEWS_RT_PROCESS' });

export const FETCH_NEWS_RT_SUCCESS = data => dispatch => dispatch({ type: 'FETCH_NEWS_RT_SUCCESS', data });

export const FETCH_NEWS_RT_ERROR = () => dispatch => dispatch({ type: 'FETCH_NEWS_RT_ERROR' }); 

export const FETCH_NEWS_RT = () => (dispatch) => { 
    dispatch(FETCH_NEWS_RT_PROCESS());
    fetchNewsRT()
        .then(data => dispatch(FETCH_NEWS_RT_SUCCESS(data)))
        .catch(() => dispatch(FETCH_NEWS_RT_ERROR()));
    return dispatch({ type: 'FETCH_NEWS_RT' });
};



// WEBPACK FOOTER //
// ./src/actions/home.actions.js